"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkAppliedVirtualCoin = exports.applyVirtualCoin = exports.getBalancesHistory = exports.getBalancesStat = exports.getKLineData = void 0;
const Statistic_1 = require("../interface/Statistic");
const trade_utils_lib_1 = require("trade_utils_lib");
function getUTCOffset() {
    return new Date().getTimezoneOffset() * 60 * -1;
}
function getRequestUrl(path) {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().balanceApiHostV2;
    return host + path;
}
function getKLineData(base, range) {
    const url = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().klineHost + "/query_unite_candle_data";
    return trade_utils_lib_1.Network.get({
        url: url,
        data: {
            base,
            quote: "USDT",
            market: "pionex.v2",
            interval: Statistic_1.LineIntervalType._1d,
            start: range.beginTime,
            end: range.endTime,
            from: "app",
        },
    });
}
exports.getKLineData = getKLineData;
function getBalancesStat() {
    const url = getRequestUrl("/trader_account/balances_stat");
    return trade_utils_lib_1.Network.get({ url, data: { tz_offset: getUTCOffset() }, authType: trade_utils_lib_1.AuthType.FullToken });
}
exports.getBalancesStat = getBalancesStat;
function getBalancesHistory(params) {
    const { beginTime, endTime } = params;
    const url = getRequestUrl("/trader_account/balances_history");
    return trade_utils_lib_1.Network.get({
        url,
        data: { tz_offset: getUTCOffset(), started_ts: beginTime, ended_ts: endTime },
        authType: trade_utils_lib_1.AuthType.FullToken,
    });
}
exports.getBalancesHistory = getBalancesHistory;
function applyVirtualCoin() {
    const url = getRequestUrl("/trader_account/vujzxy/apply");
    return trade_utils_lib_1.Network.post({
        url,
        authType: trade_utils_lib_1.AuthType.FullToken,
    });
}
exports.applyVirtualCoin = applyVirtualCoin;
function checkAppliedVirtualCoin() {
    const url = getRequestUrl("/trader_account/vujzxy/is_applied");
    return trade_utils_lib_1.Network.get({
        url,
        authType: trade_utils_lib_1.AuthType.FullToken,
    });
}
exports.checkAppliedVirtualCoin = checkAppliedVirtualCoin;
